// Dependencies
import {
  ChangeEventHandler,
  FC,
  FocusEventHandler,
  MouseEventHandler,
  useState,
} from "react";

// Components
import FormInput from "../Registration/FormInput";

// Icons
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface FormPasswordInputProps {
  label: string;
  name: string;
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
  value: string | number;
  placeholder?: string;
  autoComplete?: string;
  onIconClick?: MouseEventHandler;
}

const FormPasswordInput: FC<FormPasswordInputProps> = (props) => {
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);

  const handleHideShowPassword = () => {
    setIsShowPassword((prev) => !prev);
  };

  return (
    <FormInput
      type={isShowPassword ? "text" : "password"}
      onIconClick={handleHideShowPassword}
      icon={isShowPassword ? <VisibilityOff /> : <Visibility />}
      {...props}
    />
  );
};

export default FormPasswordInput;
